import { useAuthStore } from "@/store/authStore";

type TierType = "free" | "verified" | "premium";

const tierHierarchy: Record<TierType, number> = {
  free: 0,
  verified: 1,
  premium: 2,
};

export function useTierAccess() {
  const { user } = useAuthStore();
  const userTier = (user?.membershipTier || "free") as TierType;

  const hasAccess = (requiredTier: TierType) => {
    return tierHierarchy[userTier] >= tierHierarchy[requiredTier];
  };

  const isVerified = user?.verificationStatus === "verified" || userTier === "verified" || userTier === "premium";
  const isPremium = userTier === "premium";

  return {
    userTier,
    isVerified,
    isPremium,
    hasAccess,
    tierHierarchy,
  };
}
